/**
 * Phase / connection overlay: warmup, match winner, reconnect notice, and the
 * transient toast used for "buy window closed".
 */
import { TEAM, TEAM_NAME } from '../../net/protocol.js';
import { el, setText, setNum, setClass } from './dom.js';

export class Overlay {
  constructor(parent) {
    const root = el('div', 'cs-ov', parent);

    this.warmup = el('div', 'cs-ov-phase', root, 'WARMUP');

    const win = el('div', 'cs-ov-win', root);
    this.win = win;
    this.winTeam = el('span', 'cs-ov-team', win, '');
    el('span', 'cs-ov-sub', win, 'WINS THE MATCH');

    const net = el('div', 'cs-ov-net', root);
    this.net = net;
    el('span', null, net, 'RECONNECTING…');
    this.ping = el('span', 'cs-ov-ping', net, '0');
    el('span', null, net, 'MS');

    this.toast = el('div', 'cs-ov-toast', root, '');
    this._toast = 0;
    this.root = root;
  }

  /** Show a transient message for `life` seconds. */
  flash(text, life = 1.6) {
    setText(this.toast, text);
    this._toast = life;
  }

  update(s, dt) {
    setClass(this.warmup, 'on', s?.phase === 'warmup' && !s?.matchOver);

    const over = !!s?.matchOver;
    setClass(this.win, 'on', over);
    if (over) {
      const w = s?.winner ?? TEAM.NONE;
      setText(this.winTeam, TEAM_NAME[w] ?? '');
      setClass(this.win, 't', w === TEAM.T);
      setClass(this.win, 'ct', w === TEAM.CT);
    }

    const down = s?.connected === false;
    setClass(this.net, 'on', down);
    if (down) setNum(this.ping, s?.latencyMs ?? 0);

    if (this._toast > 0) {
      this._toast -= dt;
      setClass(this.toast, 'on', this._toast > 0);
    }
  }
}
